'use es6';

import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { activateDeveloperMode } from 'ContentEditorUI/redux/actions/queryParamActions';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { updateSelectedItem } from 'ContentEditorUI/redux/actions/selectionActions';
import bus from 'ContentEditorUI/coffee/lib/eventBus';
const DEVELOPER_MODE = 'developerMode';
const MODULE_ID = 'moduleId';

/**
 * @param {Object} props
 * @param {string} props.path (required)
 */
const SyncQueryParamsToReduxContainer = ({
  path
}) => {
  const dispatch = useDispatch();
  const hasDispatchedSelectionRef = useRef(false);
  useEffect(() => {
    // Developer Mode param
    if (path.includes(`${DEVELOPER_MODE}=true`)) {
      UsageTracker.trackEditorInteraction({
        action: 'Developer Mode',
        event: 'loaded-in-dev-mode'
      });
      dispatch(activateDeveloperMode());
    }

    // Module selection param
    let cleanup;
    if (path.includes(`${MODULE_ID}=`)) {
      const urlParams = new URLSearchParams(path);
      const moduleIdValue = urlParams.get(MODULE_ID);
      if (moduleIdValue) {
        const maybeDispatchSelection = () => {
          if (hasDispatchedSelectionRef.current) return;
          hasDispatchedSelectionRef.current = true;
          dispatch(updateSelectedItem(moduleIdValue, {
            shouldScrollToModule: true
          }));
        };
        bus.on('post:InpageModuleContext:updateModuleRef', maybeDispatchSelection);
        cleanup = () => {
          bus.off('post:InpageModuleContext:updateModuleRef', maybeDispatchSelection);
        };
      }
    }
    return cleanup;
  }, [dispatch, path]);
  return null;
};
export default SyncQueryParamsToReduxContainer;